import { BigButton } from '../../../../components/BigButton';
import RadioInput from '../../../../components/Inputs/RadioInput';
import { GenericTextInput } from '../../../../components/Inputs/styles';
import useFormModalPaymentCardLogic from '../../logic/useFormModalPaymentCardLogic';
import { Dropdown } from './../../../../components/Dropdown';
import {
    brandTypes,
    formatCVVInput,
    formatNCardInput,
    formatValidityInput
} from './logic';
import { CardFormContainer, InputRadio, Row, SpanRequired } from './styles';

export default function CardForm() {
    const {
        errors,
        register,
        handleSuccess,
        handleError,
        handleSubmit,
        setValue,
        watch,
        trigger,
    } = useFormModalPaymentCardLogic();

    const values = watch();

    return (
        <CardFormContainer onSubmit={handleSubmit(handleSuccess, handleError)}>
            <InputRadio>
                <Row>
                    <div className="input-item input-allWidth">
                        <label htmlFor="numberCard">
                            Forma de pagamento
                            <SpanRequired>*</SpanRequired>
                        </label>
                        <div
                            className={'radio-row'}
                        >
                            <div className={`radio-div  ${
                                errors['subMethod']
                                    ? 'invalid'
                                    : ''
                            }`}>
                                <RadioInput
                                    text="Crédito"
                                    radioId="payment-method-credit"
                                    value="CREDIT"
                                    currentSelected={values.subMethod}
                                    setCurrentSelected={d => {
                                        setValue('subMethod', d as string);
                                    }}
                                />
                                <RadioInput
                                    text="Débito"
                                    radioId="payment-method-debit"
                                    value="DEBIT"
                                    currentSelected={values.subMethod}
                                    setCurrentSelected={d => {
                                        setValue('subMethod', d as string);
                                    }}
                                />
                            </div>
                            {errors['subMethod'] && (
                                <span className="error-span">
                                    {errors['subMethod'].message}
                                </span>
                            )}
                        </div>
                    </div>
                </Row>
            </InputRadio>
            <Row>
                <div className="input-item input-allWidth">
                    <label htmlFor="numberCard">
                        Número do cartão
                        <SpanRequired>*</SpanRequired>
                    </label>
                    <GenericTextInput
                        id="numberCard"
                        type="text"
                        placeholder="0000 0000 0000 0000"
                        {...register('number', { onChange: formatNCardInput })}
                        maxLength={20}
                        aria-invalid={Boolean(errors['number'])}
                    />
                    {errors['number'] && (
                        <span className="error-span">
                            {errors['number'].message}
                        </span>
                    )}
                </div>
                <div className="input-item">
                    <label htmlFor="validity">
                        Validade
                        <SpanRequired>*</SpanRequired>
                    </label>
                    <GenericTextInput
                        id="validity"
                        type="text"
                        placeholder="00/00"
                        {...register('expiration', {
                            onChange: formatValidityInput,
                        })}
                        maxLength={5}
                        aria-invalid={Boolean(errors['expiration'])}
                    />
                    {errors['expiration'] && (
                        <span className="error-span">
                            {errors['expiration'].message}
                        </span>
                    )}
                </div>
                <div className="input-item">
                    <label htmlFor="cvv">
                        CVV
                        <SpanRequired>*</SpanRequired>
                    </label>
                    <GenericTextInput
                        id="cvv"
                        type="text"
                        placeholder="000"
                        maxLength={5}
                        {...register('cvv', { onChange: formatCVVInput })}
                        aria-invalid={Boolean(errors['cvv'])}
                    />
                    {errors['cvv'] && (
                        <span className="error-span">
                            {errors['cvv'].message}
                        </span>
                    )}
                </div>
            </Row>
            <Row>
                <div
                    className={`input-item input-allWidth dropdown-container ${
                        errors['brand'] ? 'invalid' : ''
                    }`}
                    onClick={(e) => e.preventDefault()}
                >
                    <label htmlFor="name">
                        Bandeira do cartão
                        <SpanRequired>*</SpanRequired>
                    </label>
                    <Dropdown
                        title="Selecione a bandeira do cartão"
                        elements={
                            brandTypes.map(brand => {
                                return {
                                    id: brand,
                                    value: brand,
                                };
                            })
                        }
                        maxWidth={700}
                        allSize={true}
                        currentSelected={values.brand}
                        setCurrentSelected={d => {
                            setValue('brand', d as string);
                            trigger();
                        }}
                    />
                    {errors['brand'] && (
                        <span className="error-span">
                            {errors['brand'].message}
                        </span>
                    )}
                </div>
            </Row>
            <Row>
                <div className="input-item input-allWidth">
                    <label htmlFor="name">
                        Nome completo do titular
                        <SpanRequired>*</SpanRequired>
                    </label>
                    <GenericTextInput
                        id="name" //
                        type="text"
                        placeholder="Ex: Gabriel Araujo"
                        {...register('name')}
                        aria-invalid={Boolean(errors['name'])}
                    />
                    {errors['name'] && (
                        <span className="error-span">
                            {errors['name'].message}
                        </span>
                    )}
                </div>
            </Row>
            <Row>
                <BigButton
                    bgColor={'primary'}
                    color={'primary'}
                    allWidth={true}
                    type="submit"
                >
                    Adicionar Cartão
                </BigButton>
            </Row>
        </CardFormContainer>
    );
}
